export default __webpack_public_path__ + "static/media/Logout.b6092967.svg";